import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from '../features/auth/authSlice';
import saveReducer from '../features/save/saveSlice';
import menuReducer from '../features/menu/menuSlice';
import dashReducer from '../features/dashboard/dashboardSlice';
import globalReducer from '../features/global/globalSlice'; 
import folderReducer from '../features/folder/folderSlice';
import contactReducer from '../features/contact/ContactSlice';
import dropdownReducer from '../features/dropdown/dropdownSlice';
import dependantReducer from '../features/dependant/dependantSlice';
import staffReducer from '../features/staff-setting/staffSettingSlice';


const persistConfig = {
	key: 'root',
	storage,
};

const rootReducer = combineReducers({
	auth: authReducer,
	global: globalReducer, 
	save: saveReducer, 
	menu:menuReducer, 
	dash:dashReducer,
	folder:folderReducer, 
	contact:contactReducer,
	dropdown:dropdownReducer,
	dependant:dependantReducer,
	staff:staffReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export const persistor = persistStore(store);
